module.exports = __webpack_public_path__ + "img/backIconRight2.bc70de75.png";